// // src/components/OrganizationTable.jsx
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Building, Mail, Phone, User, Hash, Code } from "lucide-react";

// export default function OrganizationTable() {
//   const [organizations, setOrganizations] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchOrganizations = async () => {
//     try {
//       setLoading(true);
//       // Replace with your actual API endpoint
//       const res = await axios.get("http://127.0.0.1:8000/api/organizations/");
//       setOrganizations(res.data || []);
//     } catch (error) {
//       console.error("Failed to fetch organizations:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrganizations();
//   }, []);

//   // Optional: sample data if API is not ready
//   const sampleData = [
//     {
//       org_id: "550e8400-e29b-41d4-a716-446655440000",
//       org_code: "OD-BLR-0001",
//       organization_name: "TechFlow Solutions",
//       primary_admin_name: "Test User One",
//       mobile: "8956235692",
//       email: "test1@example.com",
//     },
//     {
//       org_id: "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
//       org_code: "OD-DEL-0002",
//       organization_name: "DataVerse Corp",
//       primary_admin_name: "Aarav Sharma",
//       mobile: "9876543210",
//       email: "aarav.sharma@org.in",
//     },
//     {
//       org_id: "8f14e45f-9c3e-4f2a-8c1d-6b7e8f9a0b1c",
//       org_code: "OD-MUM-0003",
//       organization_name: "FinSight Labs",
//       primary_admin_name: "Priya Patel",
//       mobile: "8123456789",
//       email: "priya.patel@fintech.com",
//     },
//   ];

//   const dataToShow = organizations.length > 0 ? organizations : sampleData;

//   return (
//     <div className="
//       m-6 rounded-2xl shadow-2xl overflow-hidden border 
//       bg-card-bg border-card-border
//       dark:bg-card-bg dark:border-card-border
//     ">
//       {/* Header */}
//       <div className="
//         px-8 py-7 border-b flex justify-between items-center
//         bg-secondary-bg border-card-border
//         dark:bg-secondary-bg dark:border-card-border
//       ">
//         <div>
//           <h3 className="
//             text-2xl font-bold tracking-tight
//             text-primary-text
//             dark:text-primary-text
//           ">
//             Organizations
//           </h3>
//           <p className="
//             mt-1 text-sm
//             text-secondary-text
//             dark:text-secondary-text
//           ">
//             {dataToShow.length} registered {dataToShow.length === 1 ? "organization" : "organizations"}
//           </p>
//         </div>

//         {/* Optional: Add New Organization button */}
//         <button
//           className="
//             flex items-center gap-2 px-6 py-3 
//             bg-gradient-to-r from-accent-orange-600 to-accent-orange-700 
//             hover:from-accent-orange-700 hover:to-accent-orange-800 
//             text-white font-medium rounded-xl shadow-lg hover:shadow-xl 
//             transition-all duration-200 active:scale-95
//           "
//         >
//           <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
//           </svg>
//           Add Organization
//         </button>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full text-sm min-w-[1100px]">
//           <thead className="
//             border-b bg-secondary-bg border-card-border
//             dark:bg-secondary-bg dark:border-card-border
//           ">
//             <tr>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text dark:text-secondary-text">Org Code</th>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text dark:text-secondary-text">Organization Name</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Primary Admin</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Mobile</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Email</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Org ID</th>
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-card-border dark:divide-card-border">
//             {dataToShow.length === 0 ? (
//               <tr>
//                 <td colSpan={6} className="py-16 text-center text-secondary-text dark:text-secondary-text">
//                   No organizations registered yet
//                 </td>
//               </tr>
//             ) : (
//               dataToShow.map((org) => (
//                 <tr
//                   key={org.org_id}
//                   className="
//                     hover:bg-accent-orange-950/20 transition-colors duration-150 group
//                     dark:hover:bg-accent-orange-950/30
//                   "
//                 >
//                   {/* Org Code */}
//                   <td className="py-5 px-8 font-mono font-medium text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       {/* <Code className="w-4 h-4 text-accent-orange-500" /> */}
//                       {org.org_code || "—"}
//                     </div>
//                   </td>

//                   {/* Organization Name */}
//                   <td className="py-5 px-8 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-3">
//                       <div className="
//                         w-10 h-10 rounded-lg bg-gradient-to-br from-accent-orange-600/30 to-accent-orange-800/30 
//                         flex items-center justify-center text-accent-orange-400
//                       ">
//                         <Building className="w-5 h-5" />
//                       </div>
//                       {org.organization_name || "—"}
//                     </div>
//                   </td>

//                   {/* Primary Admin Name */}
//                   <td className="py-5 px-6 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       <User className="w-4 h-4 text-accent-orange-500" />
//                       {org.primary_admin_name || "—"}
//                     </div>
//                   </td>

//                   {/* Mobile */}
//                   <td className="py-5 px-6 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       <Phone className="w-4 h-4 text-accent-orange-500" />
//                       {org.mobile || "—"}
//                     </div>
//                   </td>

//                   {/* Email */}
//                   <td className="py-5 px-6 text-secondary-text dark:text-secondary-text">
//                     <div className="flex items-center gap-2">
//                       <Mail className="w-4 h-4 text-accent-orange-500" />
//                       {org.email || "—"}
//                     </div>
//                   </td>

//                   {/* Org ID */}
//                   <td className="py-5 px-6 font-mono text-secondary-text dark:text-secondary-text text-xs">
//                     {org.org_id || "—"}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }


// // src/components/OrganizationTable.jsx
// import { useState, useEffect } from "react";
// import axios from "axios";
// import { Building, Mail, Phone, User, Hash, Code, RefreshCw, Plus } from "lucide-react";

// export default function OrganizationTable() {
//   const [organizations, setOrganizations] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const fetchOrganizations = async () => {
//     try {
//       setLoading(true);
//       // Replace with your real API endpoint when ready
//       const res = await axios.get("http://127.0.0.1:8000/api/organizations/");
//       setOrganizations(res.data || []);
//     } catch (error) {
//       console.error("Failed to fetch organizations:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchOrganizations();
//   }, []);

//   // Sample data (fallback when API is not ready)
//   const sampleData = [
//     {
//       org_id: "550e8400-e29b-41d4-a716-446655440000",
//       org_code: "OR-BLR-0001",
//       organization_name: "TechFlow Solutions",
//       primary_admin_name: "Test User One",
//       mobile: "8956235692",
//       email: "test1@example.com",
//     },
//     {
//       org_id: "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
//       org_code: "OR-DEL-0002",
//       organization_name: "DataVerse Corp",
//       primary_admin_name: "Aarav Sharma",
//       mobile: "9876543210",
//       email: "aarav.sharma@org.in",
//     },
//     {
//       org_id: "8f14e45f-9c3e-4f2a-8c1d-6b7e8f9a0b1c",
//       org_code: "OR-MUM-0003",
//       organization_name: "FinSight Labs",
//       primary_admin_name: "Priya Patel",
//       mobile: "8123456789",
//       email: "priya.patel@fintech.com",
//     },
//   ];

//   const dataToShow = organizations.length > 0 ? organizations : sampleData;

//   return (
//     <div className="
//       m-6 rounded-2xl shadow-2xl overflow-hidden border 
//       bg-card-bg border-card-border
//       dark:bg-card-bg dark:border-card-border
//     ">
//       {/* Header with buttons */}
//       <div className="
//         px-8 py-7 border-b flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4
//         bg-secondary-bg border-card-border
//         dark:bg-secondary-bg dark:border-card-border
//       ">
//         <div>
//           <h3 className="
//             text-2xl font-bold tracking-tight
//             text-primary-text
//             dark:text-primary-text
//           ">
//             Organizations
//           </h3>
//           <p className="
//             mt-1 text-sm
//             text-secondary-text
//             dark:text-secondary-text
//           ">
//             {dataToShow.length} registered {dataToShow.length === 1 ? "organization" : "organizations"}
//           </p>
//         </div>

//         <div className="flex items-center gap-3">
//           {/* Refresh Button */}
//           <button
//             onClick={fetchOrganizations}
//             disabled={loading}
//             className="
//               flex items-center gap-2 px-5 py-2.5 
//               bg-accent-orange-900/30 hover:bg-accent-orange-900/50 
//               text-accent-orange-400 hover:text-accent-orange-300 
//               font-medium rounded-xl border border-accent-orange-800/50
//               transition-all duration-200 active:scale-95
//               disabled:opacity-50 disabled:cursor-not-allowed
//             "
//           >
//             <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} />
//             {loading ? "Refreshing..." : "Refresh List"}
//           </button>

//           {/* Add New Organization Button */}
//           {/* <button
//             className="
//               flex items-center gap-2 px-6 py-3 
//               bg-gradient-to-r from-accent-orange-600 to-accent-orange-700 
//               hover:from-accent-orange-700 hover:to-accent-orange-800 
//               text-white font-medium rounded-xl shadow-lg hover:shadow-xl 
//               transition-all duration-200 active:scale-95
//             "
//             onClick={() => {
//               // TODO: Open Add Organization drawer/modal here
//               alert("Add new organization form coming soon...");
//             }}
//           >
//             <Plus className="w-5 h-5" />
//             Add Organization
//           </button> */}
//         </div>
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full text-sm min-w-[1100px]">
//           <thead className="
//             border-b bg-secondary-bg border-card-border
//             dark:bg-secondary-bg dark:border-card-border
//           ">
//             <tr>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text dark:text-secondary-text">Org Code</th>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text dark:text-secondary-text">Organization Name</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Primary Admin</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Mobile</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Email</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text dark:text-secondary-text">Org ID</th>
//             </tr>
//           </thead>

//           <tbody className="divide-y divide-card-border dark:divide-card-border">
//             {dataToShow.length === 0 ? (
//               <tr>
//                 <td colSpan={6} className="py-16 text-center text-secondary-text dark:text-secondary-text">
//                   No organizations registered yet
//                 </td>
//               </tr>
//             ) : (
//               dataToShow.map((org) => (
//                 <tr
//                   key={org.org_id}
//                   className="
//                     hover:bg-accent-orange-950/20 transition-colors duration-150 group
//                     dark:hover:bg-accent-orange-950/30
//                   "
//                 >
//                   {/* Org Code */}
//                   <td className="py-5 px-8 font-mono font-medium text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       {/* <Code className="w-4 h-4 text-accent-orange-500" /> */}
//                       {org.org_code || "—"}
//                     </div>
//                   </td>

//                   {/* Organization Name */}
//                   <td className="py-5 px-8 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-3">
//                       <div className="
//                         w-10 h-10 rounded-lg bg-gradient-to-br from-accent-orange-600/30 to-accent-orange-800/30 
//                         flex items-center justify-center text-accent-orange-400
//                       ">
//                         <Building className="w-5 h-5" />
//                       </div>
//                       {org.organization_name || "—"}
//                     </div>
//                   </td>

//                   {/* Primary Admin Name */}
//                   <td className="py-5 px-6 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       <User className="w-4 h-4 text-accent-orange-500" />
//                       {org.primary_admin_name || "—"}
//                     </div>
//                   </td>

//                   {/* Mobile */}
//                   <td className="py-5 px-6 text-primary-text dark:text-primary-text">
//                     <div className="flex items-center gap-2">
//                       <Phone className="w-4 h-4 text-accent-orange-500" />
//                       {org.mobile || "—"}
//                     </div>
//                   </td>

//                   {/* Email */}
//                   <td className="py-5 px-6 text-secondary-text dark:text-secondary-text">
//                     <div className="flex items-center gap-2">
//                       <Mail className="w-4 h-4 text-accent-orange-500" />
//                       {org.email || "—"}
//                     </div>
//                   </td>

//                   {/* Org ID */}
//                   <td className="py-5 px-6 font-mono text-secondary-text dark:text-secondary-text text-xs break-all">
//                     {org.org_id || "—"}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

// // src/components/OrganizationTable.jsx
// import { useState } from "react";
// import { Building, Mail, Phone, User, Hash, RefreshCw, Plus, Eye } from "lucide-react";

// export default function OrganizationTable() {
//   const [organizations] = useState([
//     {
//       id: 1,
//       org_code: "OR-BLR-0001",
//       organization_name: "TechFlow Solutions",
//       primary_admin_name: "Test User One",
//       mobile: "8956235692",
//       email: "test1@example.com",
//       // total_cards: 10,
//       // active_cards: 10,
//       // inactive_cards: 0,
//     },
//     {
//       id: 2,
//       org_code: "OR-DEL-0002",
//       organization_name: "DataVerse Corp",
//       primary_admin_name: "Aarav Sharma",
//       mobile: "9876543210",
//       email: "aarav.sharma@org.in",
//       // total_cards: 25,
//       // active_cards: 18,
//       // inactive_cards: 7,
//     },
//     {
//       id: 3,
//       org_code: "OR-MUM-0003",
//       organization_name: "FinSight Labs",
//       primary_admin_name: "Priya Patel",
//       mobile: "8123456789",
//       email: "priya.patel@fintech.com",
//       // total_cards: 15,
//       // active_cards: 15,
//       // inactive_cards: 0,
//     },
//   ]);

//   const [selectedOrg, setSelectedOrg] = useState(null);
//   const [showAddCards, setShowAddCards] = useState(false);
//   const [numCards, setNumCards] = useState(10);
//   const [validity, setValidity] = useState(30);
//   const [paymentType, setPaymentType] = useState("online"); // online or offline

//   const openView = (org) => {
//     setSelectedOrg(org);
//     setShowAddCards(false);
//   };

//   const closeView = () => {
//     setSelectedOrg(null);
//     setShowAddCards(false);
//   };

//   const handleAddCards = () => {
//     alert(`Successfully purchased ${numCards} cards for ${selectedOrg.organization_name}!\n\nPayment Type: ${paymentType.toUpperCase()}\nValidity: ${validity} days`);
//     setShowAddCards(false);
//     setSelectedOrg(null);
//   };

//   return (
//     <div className="m-6 rounded-2xl shadow-2xl overflow-hidden border bg-card-bg border-card-border dark:bg-card-bg dark:border-card-border">
//       {/* Header */}
//       <div className="px-8 py-7 border-b flex justify-between items-center bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
//         <div>
//           <h3 className="text-2xl font-bold text-primary-text">Organizations</h3>
//           <p className="text-sm text-secondary-text mt-1">{organizations.length} registered organizations</p>
//         </div>
//         {/* <button
//           onClick={() => alert("Add new organization form coming soon...")}
//           className="flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-xl font-medium shadow-md transition"
//         >
//           <Plus className="w-5 h-5" />
//           Add Organization
//         </button> */}
//       </div>

//       {/* Table */}
//       <div className="overflow-x-auto">
//         <table className="w-full text-sm min-w-[1100px]">
//           <thead className="border-b bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
//             <tr>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Org Code</th>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Organization Name</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Primary Admin</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Mobile</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Email</th>
//               <th className="text-center py-4 px-6 font-semibold text-secondary-text">Actions</th>
//             </tr>
//           </thead>
//           {/* <tbody className="divide-y divide-card-border dark:divide-card-border">
//             {organizations.map((org) => (
//               <tr key={org.id} className="hover:bg-accent-orange-950/20 transition-colors group">
//                 <td className="py-5 px-8 font-mono text-primary-text">{org.org_code}</td>
//                 <td className="py-5 px-8 text-primary-text font-medium">{org.organization_name}</td>
//                 <td className="py-5 px-6 text-primary-text">{org.primary_admin_name}</td>
//                 <td className="py-5 px-6 text-primary-text">{org.mobile}</td>
//                 <td className="py-5 px-6 text-secondary-text">{org.email}</td>
//                 <td className="py-5 px-6 text-center">
//                   <button
//                     onClick={() => openView(org)}
//                     className="inline-flex items-center gap-2 px-5 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-medium rounded-xl transition-all active:scale-95"
//                   >
//                     <Eye className="w-4 h-4" />
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody> */}

//           <tbody className="divide-y divide-card-border dark:divide-card-border">
//   {organizations.map((org) => (
//     <tr 
//       key={org.id} 
//       className="hover:bg-accent-orange-950/20 transition-colors group"
//     >
//       {/* Org Code */}
      //  <td className="py-5 px-8 font-mono font-medium text-primary-text dark:text-primary-text">
      //                <div className="flex items-center gap-2">
      //                  {/* <Code className="w-4 h-4 text-accent-orange-500" /> */}
      //                  {org.org_code || "—"}
      //                </div>
      //              </td>

//       {/* Organization Name */}
//       <td className="py-5 px-8 text-primary-text font-medium">
//         <div className="flex items-center gap-3">
//           <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-600 to-orange-700 flex items-center justify-center text-white">
//             <Building className="w-4 h-4" />
//           </div>
//           {org.organization_name}
//         </div>
//       </td>

//       {/* Primary Admin */}
//       <td className="py-5 px-6 text-primary-text">
//         <div className="flex items-center gap-3">
//           <div className="w-8 h-8 rounded-full bg-orange-500/10 flex items-center justify-center">
//             <User className="w-4 h-4 text-orange-500" />
//           </div>
//           {org.primary_admin_name}
//         </div>
//       </td>

//       {/* Mobile */}
//       <td className="py-5 px-6 text-primary-text">
//         <div className="flex items-center gap-3">
//           <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
//             <Phone className="w-4 h-4 text-orange-500" />
//           </div>
//           {org.mobile}
//         </div>
//       </td>

//       {/* Email */}
//       <td className="py-5 px-6 text-secondary-text">
//         <div className="flex items-center gap-3">
//           <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
//             <Mail className="w-4 h-4 text-orange-500" />
//           </div>
//           {org.email}
//         </div>
//       </td>

//       {/* Actions */}
//       <td className="py-5 px-6 text-center">
//         <button
//           onClick={() => openView(org)}
//           className="inline-flex items-center gap-2 px-5 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-medium rounded-xl transition-all active:scale-95"
//         >
//           <Eye className="w-4 h-4" />
//           View
//         </button>
//       </td>
//     </tr>
//   ))}
// </tbody>
//         </table>
//       </div>

//       {/* ==================== VIEW ORGANIZATION MODAL ==================== */}
//       {selectedOrg && (
//         <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
//           <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-5xl max-h-[92vh] overflow-hidden shadow-2xl">
//             {/* Modal Header */}
//             <div className="px-8 py-6 border-b border-card-border flex justify-between items-center">
//               <div>
//                 <h2 className="text-2xl font-bold text-primary-text">{selectedOrg.organization_name}</h2>
//                 <p className="text-secondary-text mt-1">{selectedOrg.org_code}</p>
//               </div>
//               <button onClick={closeView} className="text-secondary-text hover:text-white">
//                 ✕
//               </button>
//             </div>

//             {/* Stats Cards */}
//             {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-8 border-b border-card-border">
//               <div className="bg-secondary-bg rounded-2xl p-6 border border-card-border">
//                 <p className="text-secondary-text text-sm">Total Cards</p>
//                 <p className="text-5xl font-bold text-white mt-2">{selectedOrg.total_cards}</p>
//               </div>
//               <div className="bg-secondary-bg rounded-2xl p-6 border border-card-border">
//                 <p className="text-secondary-text text-sm">Active Cards</p>
//                 <p className="text-5xl font-bold text-green-500 mt-2">{selectedOrg.active_cards}</p>
//               </div>
//               <div className="bg-secondary-bg rounded-2xl p-6 border border-card-border">
//                 <p className="text-secondary-text text-sm">Inactive Cards</p>
//                 <p className="text-5xl font-bold text-red-500 mt-2">{selectedOrg.inactive_cards}</p>
//               </div>
//             </div> */}

//             {/* Action Buttons */}
//             <div className="px-8 py-5 flex flex-wrap gap-3 border-b border-card-border">
//               <button
//                 onClick={() => setShowAddCards(true)}
//                 className="flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium shadow transition"
//               >
//                 <Plus className="w-5 h-5" />
//                 + Package purchase
//               </button>
//               <button className="px-6 py-3 border border-card-border hover:bg-secondary-bg rounded-2xl transition">
//                 Refresh
//               </button>
//               <button className="px-6 py-3 border border-card-border hover:bg-secondary-bg rounded-2xl transition">
//                 Export Excel
//               </button>
//             </div>

//             {/* Transactions Table */}
//             <div className="p-8">
//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead>
//                     <tr className="border-b border-card-border">
//                       <th className="text-left py-4 px-6 text-secondary-text">DATE</th>
//                       {/* <th className="text-left py-4 px-6 text-secondary-text">CARDS</th> */}
//                       <th className="text-left py-4 px-6 text-secondary-text">EXPIRY</th>
//                       <th className="text-left py-4 px-6 text-secondary-text">STATUS</th>
//                       <th className="text-left py-4 px-6 text-secondary-text">PAYMENT STATUS</th>
//                       <th className="text-right py-4 px-6 text-secondary-text">AMOUNT</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr className="border-b border-card-border hover:bg-secondary-bg/50">
//                       <td className="py-5 px-6">5/3/2026</td>
//                       {/* <td className="py-5 px-6">10</td> */}
//                       <td className="py-5 px-6">2026-04-04</td>
//                       <td className="py-5 px-6">
//                         <span className="px-4 py-1 bg-red-500/20 text-red-400 rounded-full text-xs">Expired</span>
//                       </td>
//                       <td className="py-5 px-6">
//                         <span className="px-4 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">Paid</span>
//                       </td>
//                       <td className="py-5 px-6 text-right font-medium text-orange-500">₹1,100</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ==================== ADD CARDS DRAWER ==================== */}
//       {showAddCards && selectedOrg && (
//         <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4">
//           <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-lg overflow-hidden">
//             <div className="p-6 border-b border-card-border flex justify-between items-center">
//               <div>
//                 <h3 className="text-xl font-bold">Add Package</h3>
//                 <p className="text-sm text-secondary-text">Purchase package for this organization</p>
//               </div>
//               <button onClick={() => setShowAddCards(false)} className="text-2xl text-secondary-text hover:text-white">✕</button>
//             </div>

//             <div className="p-6 space-y-6">
//               {/* <div>
//                 <label className="block text-sm font-medium mb-2">Number of Cards</label>
//                 <input
//                   type="number"
//                   value={numCards}
//                   onChange={(e) => setNumCards(parseInt(e.target.value) || 1)}
//                   className="w-full px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl text-lg"
//                 />
//               </div> */}

//               <div>
//                 <label className="block text-sm font-medium mb-2">Validity Period</label>
//                 <select
//                   value={validity}
//                   onChange={(e) => setValidity(parseInt(e.target.value))}
//                   className="w-full px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl"
//                 >
//                   <option value={30}>30  Trail Offer</option>
//                   <option value={60}>1 year</option>
//                   <option value={90}>2 year</option>
//                 </select>
//               </div>

            //   <div>
            //     <label className="block text-sm font-medium mb-3">Payment Type</label>
            //     <div className="grid grid-cols-2 gap-4">
            //       <button
            //         onClick={() => setPaymentType("online")}
            //         className={`p-4 rounded-2xl border transition-all ${paymentType === "online" ? "border-orange-500 bg-orange-950/30" : "border-card-border hover:border-orange-600"}`}
            //       >
            //         <div className="text-2xl mb-2">💳</div>
            //         <div className="font-medium">Online Payment</div>
            //         <div className="text-xs text-secondary-text">UPI, Card, Netbanking</div>
            //       </button>

            //       <button
            //         onClick={() => setPaymentType("offline")}
            //         className={`p-4 rounded-2xl border transition-all ${paymentType === "offline" ? "border-orange-500 bg-orange-950/30" : "border-card-border hover:border-orange-600"}`}
            //       >
            //         <div className="text-2xl mb-2">🏦</div>
            //         <div className="font-medium">Cash / Offline</div>
            //         <div className="text-xs text-secondary-text">Bank transfer or cash</div>
            //       </button>
            //     </div>
            //   </div>

            //   <div className="pt-4 border-t border-card-border">
            //     <div className="flex justify-between text-sm mb-1">
            //       <span>Price per card</span>
            //       <span className="font-medium">₹110</span>
            //     </div>
            //     <div className="flex justify-between text-lg font-bold">
            //       <span>Total Amount</span>
            //       <span className="text-orange-500">₹{numCards * 110}</span>
            //     </div>
            //   </div>
            // </div>

//             <div className="p-6 border-t border-card-border flex gap-3">
//               <button
//                 onClick={() => setShowAddCards(false)}
//                 className="flex-1 py-3 border border-card-border rounded-2xl font-medium hover:bg-secondary-bg transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleAddCards}
//                 className="flex-1 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium transition"
//               >
//                 Confirm & Pay
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


// // src/components/OrganizationTable.jsx
// import { useState } from "react";
// import { Building, Mail, Phone, User, Hash, Eye, Plus } from "lucide-react";

// export default function OrganizationTable() {
//   const [organizations] = useState([
//     {
//       id: 1,
//       org_code: "OR-BLR-0001",
//       organization_name: "TechFlow Solutions",
//       primary_admin_name: "Test User One",
//       mobile: "8956235692",
//       email: "test1@example.com",
//     },
//     {
//       id: 2,
//       org_code: "OR-DEL-0002",
//       organization_name: "DataVerse Corp",
//       primary_admin_name: "Aarav Sharma",
//       mobile: "9876543210",
//       email: "aarav.sharma@org.in",
//     },
//     {
//       id: 3,
//       org_code: "OR-MUM-0003",
//       organization_name: "FinSight Labs",
//       primary_admin_name: "Priya Patel",
//       mobile: "8123456789",
//       email: "priya.patel@fintech.com",
//     },
//   ]);

//   const [selectedOrg, setSelectedOrg] = useState(null);
//   const [showAddPackage, setShowAddPackage] = useState(false);
// const [paymentType, setPaymentType] = useState("online"); // online / offline
//   // Add Package Form State
//   const [paymentMethod, setPaymentMethod] = useState("upi"); // "upi" or "card"
//   const [numCards, setNumCards] = useState(10);
//   const [validity, setValidity] = useState(30);
//   const [proofFile, setProofFile] = useState(null);
// const [couponCode, setCouponCode] = useState("");
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [discount, setDiscount] = useState(0);
//   const openView = (org) => {
//     setSelectedOrg(org);
//     setShowAddPackage(false);
//   };

//   const closeView = () => {
//     setSelectedOrg(null);
//     setShowAddPackage(false);
//   };
// const resetForm = () => {
//     setCouponCode("");
//     setCouponApplied(false);
//     setDiscount(0);
//     setProofFile(null);
//   }
//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) setProofFile(file);
//   };

//   const handleConfirmPayment = () => {
//     alert(`Payment Successful!\n\nOrganization: ${selectedOrg.organization_name}\nCards: ${numCards}\nAmount: ₹${numCards * 110}\nPayment Method: ${paymentMethod.toUpperCase()}`);
//     setShowAddPackage(false);
//     setSelectedOrg(null);
//     setProofFile(null);
//   };const applyCoupon = () => {
//     if (!couponCode.trim()) return alert("Please enter a coupon code");

//     // Demo coupon logic
//     if (couponCode.toUpperCase() === "WELCOME10" || couponCode.toUpperCase() === "ONEDESK10") {
//       setDiscount(10); // 10% discount
//       setCouponApplied(true);
//       alert("Coupon 'WELCOME10' applied! 10% discount");
//     } else if (couponCode.toUpperCase() === "FIRST50") {
//       setDiscount(50);
//       setCouponApplied(true);
//       alert("Coupon 'FIRST50' applied! 50% discount");
//     } else {
//       alert("Invalid coupon code");
//     }
//   };

//   const removeCoupon = () => {
//     setCouponCode("");
//     setCouponApplied(false);
//     setDiscount(0);
//   };const calculateTotal = () => {
//     const baseAmount = numCards * 110;
//     const discountAmount = baseAmount * (discount / 100);
//     return Math.round(baseAmount - discountAmount);
//   };
//   return (
//     <div className="m-6 rounded-2xl shadow-2xl overflow-hidden border bg-card-bg border-card-border dark:bg-card-bg dark:border-card-border">
//       {/* Header */}
//       <div className="px-8 py-7 border-b flex justify-between items-center bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
//         <div>
//           <h3 className="text-2xl font-bold text-primary-text">Organizations</h3>
//           <p className="text-sm text-secondary-text mt-1">{organizations.length} registered organizations</p>
//         </div>
//       </div>

//       {/* Table with Icons */}
//       <div className="overflow-x-auto">
//         <table className="w-full text-sm min-w-[1100px]">
//           <thead className="border-b bg-secondary-bg border-card-border dark:bg-secondary-bg dark:border-card-border">
//             <tr>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Org Code</th>
//               <th className="text-left py-4 px-8 font-semibold text-secondary-text">Organization Name</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Primary Admin</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Mobile</th>
//               <th className="text-left py-4 px-6 font-semibold text-secondary-text">Email</th>
//               <th className="text-center py-4 px-6 font-semibold text-secondary-text">Actions</th>
//             </tr>
//           </thead>
//           <tbody className="divide-y divide-card-border dark:divide-card-border">
//             {organizations.map((org) => (
//               <tr key={org.id} className="hover:bg-accent-orange-950/20 transition-colors group">
//                   <td className="py-5 px-8 font-mono font-medium text-primary-text dark:text-primary-text">
//                      <div className="flex items-center gap-2">
//                        {/* <Code className="w-4 h-4 text-accent-orange-500" /> */}
//                        {org.org_code || "—"}
//                      </div>
//                    </td>

//                 <td className="py-5 px-8 text-primary-text font-medium">
//                   <div className="flex items-center gap-3">
//                     <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-600 to-orange-700 flex items-center justify-center text-white">
//                       <Building className="w-4 h-4" />
//                     </div>
//                     {org.organization_name}
//                   </div>
//                 </td>
//                 <td className="py-5 px-6 text-primary-text">
//                   <div className="flex items-center gap-3">
//                     <div className="w-8 h-8 rounded-full bg-orange-500/10 flex items-center justify-center">
//                       <User className="w-4 h-4 text-orange-500" />
//                     </div>
//                     {org.primary_admin_name}
//                   </div>
//                 </td>
//                 <td className="py-5 px-6 text-primary-text">
//                   <div className="flex items-center gap-3">
//                     <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
//                       <Phone className="w-4 h-4 text-orange-500" />
//                     </div>
//                     {org.mobile}
//                   </div>
//                 </td>
//                 <td className="py-5 px-6 text-secondary-text">
//                   <div className="flex items-center gap-3">
//                     <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
//                       <Mail className="w-4 h-4 text-orange-500" />
//                     </div>
//                     {org.email}
//                   </div>
//                 </td>
//                 <td className="py-5 px-6 text-center">
//                   <button
//                     onClick={() => openView(org)}
//                     className="inline-flex items-center gap-2 px-5 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-medium rounded-xl transition-all active:scale-95"
//                   >
//                     <Eye className="w-4 h-4" />
//                     View
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       {/* ==================== ORGANIZATION VIEW MODAL ==================== */}
//       {selectedOrg && (
//         <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
//           <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-5xl max-h-[92vh] overflow-hidden shadow-2xl">
//             <div className="px-8 py-6 border-b border-card-border flex justify-between items-center">
//               <div>
//                 <h2 className="text-2xl font-bold text-primary-text">{selectedOrg.organization_name}</h2>
//                 <p className="text-secondary-text mt-1">{selectedOrg.org_code}</p>
//               </div>
//               <button onClick={closeView} className="text-2xl text-secondary-text hover:text-white">✕</button>
//             </div>

//             <div className="p-8">
//               <button
//                 onClick={() => setShowAddPackage(true)}
//                 className="flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium shadow transition mb-8"
//               >
//                 <Plus className="w-5 h-5" />
//                 + Package Purchase
//               </button>

//               {/* Transactions Table */}
//               <div className="overflow-x-auto">
//                 <table className="w-full">
//                   <thead>
//                     <tr className="border-b border-card-border">
//                       <th className="text-left py-4 px-6 text-secondary-text">DATE</th>
//                       <th className="text-left py-4 px-6 text-secondary-text">EXPIRY</th>
//                       <th className="text-left py-4 px-6 text-secondary-text">STATUS</th>
//                       <th className="text-left py-4 px-6 text-secondary-text">PAYMENT STATUS</th>
//                       <th className="text-right py-4 px-6 text-secondary-text">AMOUNT</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     <tr className="border-b border-card-border hover:bg-secondary-bg/50">
//                       <td className="py-5 px-6">5/3/2026</td>
//                       <td className="py-5 px-6">2026-04-04</td>
//                       <td className="py-5 px-6">
//                         <span className="px-4 py-1 bg-red-500/20 text-red-400 rounded-full text-xs">Expired</span>
//                       </td>
//                       <td className="py-5 px-6">
//                         <span className="px-4 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">Paid</span>
//                       </td>
//                       <td className="py-5 px-6 text-right font-medium text-orange-500">₹1,100</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ==================== ADD PACKAGE DRAWER (with UPI + Proof) ==================== */}
//       {/* {showAddPackage && selectedOrg && (
        
//         <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4">
//           <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-lg overflow-hidden">
//             <div className="p-6 border-b border-card-border flex justify-between items-center">
//               <div>
//                 <h3 className="text-xl font-bold">Add Package</h3>
//                 <p className="text-sm text-secondary-text">Purchase for {selectedOrg.organization_name}</p>
//               </div>
//               <button onClick={() => setShowAddPackage(false)} className="text-2xl text-secondary-text hover:text-white">✕</button>
//             </div>

//             <div className="p-6 space-y-8">
            
//               <div>
//                 <label className="block text-sm font-medium mb-2">Validity Period</label>
//                 <select
//                   value={validity}
//                   onChange={(e) => setValidity(parseInt(e.target.value))}
//                   className="w-full px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl"
//                 >
//                   <option value={30}>30 Days - Trail Offer</option>
//                   <option value={365}>1 Year</option>
//                   <option value={730}>2 Years</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-400 mb-3">Payment Type</label>
//                 <div className="grid grid-cols-2 gap-4">
//                   <button
//                     onClick={() => setPaymentType("online")}
//                     className={`p-5 rounded-2xl border transition-all ${paymentType === "online" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
//                   >
//                     <div className="text-3xl mb-2">💳</div>
//                     <p className="font-medium text-white">Online Payment</p>
//                     <p className="text-xs text-gray-500">UPI, Card, Netbanking</p>
//                   </button>

//                   <button
//                     onClick={() => setPaymentType("offline")}
//                     className={`p-5 rounded-2xl border transition-all ${paymentType === "offline" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
//                   >
//                     <div className="text-3xl mb-2">🏦</div>
//                     <p className="font-medium text-white">Cash / Offline</p>
//                     <p className="text-xs text-gray-500">Bank transfer or cash</p>
//                   </button>
//                 </div>
//               </div>
//               <div>
//                 <label className="block text-sm font-medium mb-3">Payment Method</label>
//                 <div className="flex gap-3">
//                   <button
//                     onClick={() => setPaymentMethod("upi")}
//                     className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "upi" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
//                   >
//                     UPI
//                   </button>
//                   <button
//                     onClick={() => setPaymentMethod("card")}
//                     className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "card" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
//                   >
//                     Credit/Debit Card
//                   </button>
//                 </div>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium mb-3">Payment Proof</label>
//                 <div className="border-2 border-dashed border-card-border rounded-2xl p-8 text-center hover:border-orange-500 transition">
//                   <input
//                     type="file"
//                     accept="image/*"
//                     onChange={handleFileUpload}
//                     className="hidden"
//                     id="proof-upload"
//                   />
//                   <label htmlFor="proof-upload" className="cursor-pointer block">
//                     <div className="mx-auto w-12 h-12 rounded-full bg-orange-500/10 flex items-center justify-center mb-3">
//                       ↑
//                     </div>
//                     <p className="font-medium">Click to upload payment proof (image)</p>
//                     <p className="text-xs text-secondary-text mt-1">PNG, JPG or JPEG • Max 2MB</p>
//                   </label>
//                 </div>

//                 {proofFile && (
//                   <p className="text-xs text-green-500 mt-2">✓ {proofFile.name}</p>
//                 )}
//               </div>

              
//               <div className="bg-orange-950/30 border border-orange-500/30 rounded-2xl p-5">
//                 <div className="flex justify-between text-sm">
//                   <span>Price per card</span>
//                   <span>₹110</span>
//                 </div>
//                 <div className="flex justify-between text-xl font-bold mt-2">
//                   <span>Total Amount</span>
//                   <span className="text-orange-500">₹{numCards * 110}</span>
//                 </div>
//               </div>
//             </div>

//             <div className="p-6 border-t border-card-border flex gap-3">
//               <button
//                 onClick={() => setShowAddPackage(false)}
//                 className="flex-1 py-3.5 border border-card-border rounded-2xl font-medium hover:bg-secondary-bg transition"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={handleConfirmPayment}
//                 className="flex-1 py-3.5 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium transition"
//               >
//                 Confirm & Pay
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}
//       {showAddPackage && selectedOrg && (
//   <div className="fixed inset-0 z-[60] flex items-end md:items-center justify-center bg-black/70">
//     {/* Drawer Container */}
//     <div 
//       className="bg-card-bg border border-card-border rounded-t-3xl md:rounded-3xl 
//                  w-full max-w-lg md:max-w-md overflow-hidden 
//                  translate-y-0 md:translate-y-0
//                  transition-transform duration-300 ease-out
//                  max-h-[90vh] overflow-y-auto"
//     >
//       {/* Header */}
//       <div className="p-6 border-b border-card-border flex justify-between items-center sticky top-0 bg-card-bg z-10">
//         <div>
//           <h3 className="text-xl font-bold">Add Package</h3>
//           <p className="text-sm text-secondary-text">
//             Purchase for {selectedOrg.organization_name}
//           </p>
//         </div>
//         <button 
//           onClick={() => setShowAddPackage(false)} 
//           className="text-2xl text-secondary-text hover:text-white transition-colors"
//         >
//           ✕
//         </button>
//       </div>

//       {/* Content */}
//       <div className="p-6 space-y-8">
//         {/* Validity Period */}
//         <div>
//           <label className="block text-sm font-medium mb-2">Validity Period</label>
//           <select
//             value={validity}
//             onChange={(e) => setValidity(parseInt(e.target.value))}
//             className="w-full px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl"
//           >
//             <option value={30}>30 Days - Trail Offer</option>
//             <option value={365}>1 Year</option>
//             <option value={730}>2 Years</option>
//           </select>
//         </div>

//         {/* Payment Type */}
//         <div>
//           <label className="block text-sm font-medium text-gray-400 mb-3">Payment Type</label>
//           <div className="grid grid-cols-2 gap-4">
//             <button
//               onClick={() => setPaymentType("online")}
//               className={`p-5 rounded-2xl border transition-all ${paymentType === "online" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
//             >
//               <div className="text-3xl mb-2">💳</div>
//               <p className="font-medium text-white">Online Payment</p>
//               <p className="text-xs text-gray-500">UPI, Card, Netbanking</p>
//             </button>

//             <button
//               onClick={() => setPaymentType("offline")}
//               className={`p-5 rounded-2xl border transition-all ${paymentType === "offline" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
//             >
//               <div className="text-3xl mb-2">🏦</div>
//               <p className="font-medium text-white">Cash / Offline</p>
//               <p className="text-xs text-gray-500">Bank transfer or cash</p>
//             </button>
//           </div>
//         </div>

//         {/* Payment Method */}
//         <div>
//           <label className="block text-sm font-medium mb-3">Payment Method</label>
//           <div className="flex gap-3">
//             <button
//               onClick={() => setPaymentMethod("upi")}
//               className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "upi" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
//             >
//               UPI
//             </button>
//             <button
//               onClick={() => setPaymentMethod("card")}
//               className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "card" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
//             >
//               Credit/Debit Card
//             </button>
//           </div>
//         </div>

//         {/* Payment Proof */}
//         <div>
//           <label className="block text-sm font-medium mb-3">Payment Proof</label>
//           <div className="border-2 border-dashed border-card-border rounded-2xl p-8 text-center hover:border-orange-500 transition">
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileUpload}
//               className="hidden"
//               id="proof-upload"
//             />
//             <label htmlFor="proof-upload" className="cursor-pointer block">
//               <div className="mx-auto w-12 h-12 rounded-full bg-orange-500/10 flex items-center justify-center mb-3">
//                 ↑
//               </div>
//               <p className="font-medium">Click to upload payment proof (image)</p>
//               <p className="text-xs text-secondary-text mt-1">PNG, JPG or JPEG • Max 2MB</p>
//             </label>
//           </div>

//           {proofFile && (
//             <p className="text-xs text-green-500 mt-2">✓ {proofFile.name}</p>
//           )}
//         </div>

//         {/* Total Amount */}
//         <div className="bg-orange-950/30 border border-orange-500/30 rounded-2xl p-5">
//           <div className="flex justify-between text-sm">
//             <span>Price per card</span>
//             <span>₹110</span>
//           </div>
//           <div className="flex justify-between text-xl font-bold mt-2">
//             <span>Total Amount</span>
//             <span className="text-orange-500">₹{numCards * 110}</span>
//           </div>
//         </div>
//       </div>

//       {/* Footer Buttons */}
//       <div className="p-6 border-t border-card-border flex gap-3 sticky bottom-0 bg-card-bg">
//         <button
//           onClick={() => setShowAddPackage(false)}
//           className="flex-1 py-3.5 border border-card-border rounded-2xl font-medium hover:bg-secondary-bg transition"
//         >
//           Cancel
//         </button>
//         <button
//           onClick={handleConfirmPayment}
//           className="flex-1 py-3.5 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium transition"
//         >
//           Confirm & Pay
//         </button>
//       </div>
//     </div>
//   </div>
// )}
//     </div>
//   );
// }

// src/components/OrganizationTable.jsx
import { useState } from "react";
import { Building, Mail, Phone, User, Eye, Plus } from "lucide-react";

export default function OrganizationTable() {
  const [organizations] = useState([
    {
      id: 1,
      org_code: "OR-BLR-0001",
      organization_name: "TechFlow Solutions",
      primary_admin_name: "Test User One",
      mobile: "8956235692",
      email: "test1@example.com",
    },
    {
      id: 2,
      org_code: "OR-DEL-0002",
      organization_name: "DataVerse Corp",
      primary_admin_name: "Aarav Sharma",
      mobile: "9876543210",
      email: "aarav.sharma@org.in",
    },
    {
      id: 3,
      org_code: "OR-MUM-0003",
      organization_name: "FinSight Labs",
      primary_admin_name: "Priya Patel",
      mobile: "8123456789",
      email: "priya.patel@fintech.com",
    },
  ]);

  const [selectedOrg, setSelectedOrg] = useState(null);
  const [showAddPackage, setShowAddPackage] = useState(false);

  // Add Package Form State
  const [paymentType, setPaymentType] = useState("online");
  const [paymentMethod, setPaymentMethod] = useState("upi");
  const [numCards, setNumCards] = useState(10);
  const [validity, setValidity] = useState(30);
  const [proofFile, setProofFile] = useState(null);

  // Coupon States
  const [couponCode, setCouponCode] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [discount, setDiscount] = useState(0);

  const openView = (org) => {
    setSelectedOrg(org);
    setShowAddPackage(false);
  };

  const closeView = () => {
    setSelectedOrg(null);
    setShowAddPackage(false);
  };

  const resetForm = () => {
    setCouponCode("");
    setCouponApplied(false);
    setDiscount(0);
    setProofFile(null);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) setProofFile(file);
  };

  const applyCoupon = () => {
    if (!couponCode.trim()) return alert("Please enter a coupon code");

    const code = couponCode.toUpperCase().trim();

    if (code === "WELCOME10" || code === "ONEDESK10") {
      setDiscount(10);
      setCouponApplied(true);
      alert("✅ Coupon 'WELCOME10' applied! 10% discount");
    } else if (code === "FIRST50") {
      setDiscount(50);
      setCouponApplied(true);
      alert("✅ Coupon 'FIRST50' applied! 50% discount");
    } else {
      alert("❌ Invalid coupon code");
    }
  };

  const removeCoupon = () => {
    setCouponCode("");
    setCouponApplied(false);
    setDiscount(0);
  };

  const calculateTotal = () => {
    const baseAmount = numCards * 110;
    const discountAmount = baseAmount * (discount / 100);
    return Math.round(baseAmount - discountAmount);
  };

  const handleConfirmPayment = () => {
    const finalAmount = calculateTotal();
    alert(`Payment Successful!\n\nOrganization: ${selectedOrg.organization_name}\nCards: ${numCards}\nAmount: ₹${finalAmount}\nPayment Method: ${paymentMethod.toUpperCase()}`);
    
    setShowAddPackage(false);
    setSelectedOrg(null);
    resetForm();
  };

  return (
    <div className="m-6 rounded-2xl shadow-2xl overflow-hidden border bg-card-bg border-card-border">
      {/* Header */}
      <div className="px-8 py-7 border-b flex justify-between items-center bg-secondary-bg border-card-border">
        <div>
          <h3 className="text-2xl font-bold text-primary-text">Organizations</h3>
          <p className="text-sm text-secondary-text mt-1">{organizations.length} registered organizations</p>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm min-w-[1100px]">
          <thead className="border-b bg-secondary-bg border-card-border">
            <tr>
              <th className="text-left py-4 px-8 font-semibold text-secondary-text">Org Code</th>
              <th className="text-left py-4 px-8 font-semibold text-secondary-text">Organization Name</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Primary Admin</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Mobile</th>
              <th className="text-left py-4 px-6 font-semibold text-secondary-text">Email</th>
              <th className="text-center py-4 px-6 font-semibold text-secondary-text">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-card-border">
            {organizations.map((org) => (
              <tr key={org.id} className="hover:bg-accent-orange-950/20 transition-colors group">
                <td className="py-5 px-8 font-mono font-medium text-primary-text">
                  {org.org_code || "—"}
                </td>
                <td className="py-5 px-8 text-primary-text font-medium">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-orange-600 to-orange-700 flex items-center justify-center text-white">
                      <Building className="w-4 h-4" />
                    </div>
                    {org.organization_name}
                  </div>
                </td>
                <td className="py-5 px-6 text-primary-text">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-orange-500/10 flex items-center justify-center">
                      <User className="w-4 h-4 text-orange-500" />
                    </div>
                    {org.primary_admin_name}
                  </div>
                </td>
                <td className="py-5 px-6 text-primary-text">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
                      <Phone className="w-4 h-4 text-orange-500" />
                    </div>
                    {org.mobile}
                  </div>
                </td>
                <td className="py-5 px-6 text-secondary-text">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-orange-500/10 flex items-center justify-center">
                      <Mail className="w-4 h-4 text-orange-500" />
                    </div>
                    {org.email}
                  </div>
                </td>
                <td className="py-5 px-6 text-center">
                  <button
                    onClick={() => openView(org)}
                    className="inline-flex items-center gap-2 px-5 py-2 bg-orange-600 hover:bg-orange-700 text-white text-sm font-medium rounded-xl transition-all active:scale-95"
                  >
                    <Eye className="w-4 h-4" />
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Organization View Modal */}
      {selectedOrg && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
          <div className="bg-card-bg border border-card-border rounded-3xl w-full max-w-5xl max-h-[92vh] overflow-hidden shadow-2xl">
            <div className="px-8 py-6 border-b border-card-border flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-primary-text">{selectedOrg.organization_name}</h2>
                <p className="text-secondary-text mt-1">{selectedOrg.org_code}</p>
              </div>
              <button onClick={closeView} className="text-2xl text-secondary-text hover:text-white">✕</button>
            </div>

            <div className="p-8">
              <button
                onClick={() => setShowAddPackage(true)}
                className="flex items-center gap-2 px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium shadow transition mb-8"
              >
                <Plus className="w-5 h-5" />
                + Package Purchase
              </button>

              {/* Transactions Table */}
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b border-card-border">
                      <th className="text-left py-4 px-6 text-secondary-text">DATE</th>
                      <th className="text-left py-4 px-6 text-secondary-text">EXPIRY</th>
                      <th className="text-left py-4 px-6 text-secondary-text">STATUS</th>
                      <th className="text-left py-4 px-6 text-secondary-text">PAYMENT STATUS</th>
                      <th className="text-right py-4 px-6 text-secondary-text">AMOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-card-border hover:bg-secondary-bg/50">
                      <td className="py-5 px-6">5/3/2026</td>
                      <td className="py-5 px-6">2026-04-04</td>
                      <td className="py-5 px-6">
                        <span className="px-4 py-1 bg-red-500/20 text-red-400 rounded-full text-xs">Expired</span>
                      </td>
                      <td className="py-5 px-6">
                        <span className="px-4 py-1 bg-green-500/20 text-green-400 rounded-full text-xs">Paid</span>
                      </td>
                      <td className="py-5 px-6 text-right font-medium text-orange-500">₹1,100</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==================== ADD PACKAGE DRAWER WITH COUPON ==================== */}
      {showAddPackage && selectedOrg && (
        <div className="fixed inset-0 z-[60] flex items-end md:items-center justify-center bg-black/70">
          <div className="bg-card-bg border border-card-border rounded-t-3xl md:rounded-3xl 
                          w-full max-w-lg md:max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">

            {/* Header */}
            <div className="p-6 border-b border-card-border flex justify-between items-center sticky top-0 bg-card-bg z-10">
              <div>
                <h3 className="text-xl font-bold">Add Package</h3>
                <p className="text-sm text-secondary-text">
                  Purchase for {selectedOrg.organization_name}
                </p>
              </div>
              <button 
                onClick={() => { setShowAddPackage(false); resetForm(); }} 
                className="text-2xl text-secondary-text hover:text-white transition-colors"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-8">
              {/* Validity Period */}
              <div>
                <label className="block text-sm font-medium mb-2">Validity Period</label>
                <select
                  value={validity}
                  onChange={(e) => setValidity(parseInt(e.target.value))}
                  className="w-full px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl"
                >
                  <option value={30}>30 Days - Trail Offer</option>
                  <option value={365}>1 Year</option>
                  <option value={730}>2 Years</option>
                </select>
              </div>

              {/* Payment Type */}
              <div>
                <label className="block text-sm font-medium text-gray-400 mb-3">Payment Type</label>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => setPaymentType("online")}
                    className={`p-5 rounded-2xl border transition-all ${paymentType === "online" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
                  >
                    <div className="text-3xl mb-2">💳</div>
                    <p className="font-medium text-white">Online Payment</p>
                    <p className="text-xs text-gray-500">UPI, Card, Netbanking</p>
                  </button>

                  <button
                    onClick={() => setPaymentType("offline")}
                    className={`p-5 rounded-2xl border transition-all ${paymentType === "offline" ? "border-orange-600 bg-orange-950/30" : "border-gray-700 hover:border-gray-600"}`}
                  >
                    <div className="text-3xl mb-2">🏦</div>
                    <p className="font-medium text-white">Cash / Offline</p>
                    <p className="text-xs text-gray-500">Bank transfer or cash</p>
                  </button>
                </div>
              </div>

              {/* Payment Method */}
              <div>
                <label className="block text-sm font-medium mb-3">Payment Method</label>
                <div className="flex gap-3">
                  <button
                    onClick={() => setPaymentMethod("upi")}
                    className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "upi" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
                  >
                    UPI
                  </button>
                  <button
                    onClick={() => setPaymentMethod("card")}
                    className={`flex-1 py-3 rounded-2xl font-medium transition-all ${paymentMethod === "card" ? "bg-orange-600 text-white" : "bg-secondary-bg border border-card-border"}`}
                  >
                    Credit/Debit Card
                  </button>
                </div>
              </div>

              {/* Payment Proof */}
              <div>
                <label className="block text-sm font-medium mb-3">Payment Proof</label>
                <div className="border-2 border-dashed border-card-border rounded-2xl p-8 text-center hover:border-orange-500 transition">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFileUpload}
                    className="hidden"
                    id="proof-upload"
                  />
                  <label htmlFor="proof-upload" className="cursor-pointer block">
                    <div className="mx-auto w-12 h-12 rounded-full bg-orange-500/10 flex items-center justify-center mb-3">↑</div>
                    <p className="font-medium">Click to upload payment proof (image)</p>
                    <p className="text-xs text-secondary-text mt-1">PNG, JPG or JPEG • Max 2MB</p>
                  </label>
                </div>
                {proofFile && (
                  <p className="text-xs text-green-500 mt-2">✓ {proofFile.name}</p>
                )}
              </div>

              {/* ====================== COUPON SECTION ====================== */}
              <div>
                <label className="block text-sm font-medium mb-3">Have a Coupon?</label>
                <div className="flex gap-3">
                  <input
                    type="text"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                    placeholder="Enter coupon code (e.g. WELCOME10)"
                    className="flex-1 px-4 py-3 bg-secondary-bg border border-card-border rounded-2xl focus:outline-none focus:border-orange-500"
                  />
                  <button
                    onClick={applyCoupon}
                    disabled={!couponCode.trim()}
                    className="px-6 py-3 bg-orange-600 hover:bg-orange-700 disabled:bg-gray-700 disabled:cursor-not-allowed text-white font-medium rounded-2xl transition"
                  >
                    Apply
                  </button>
                </div>

                {couponApplied && (
                  <div className="mt-3 flex items-center justify-between bg-green-900/30 border border-green-500/30 rounded-2xl px-4 py-3">
                    <div className="flex items-center gap-2">
                      <span className="text-green-500">✓</span>
                      <span className="text-sm font-medium text-green-400">
                        {couponCode} applied ({discount}% OFF)
                      </span>
                    </div>
                    <button
                      onClick={removeCoupon}
                      className="text-xs text-red-400 hover:text-red-500 underline"
                    >
                      Remove
                    </button>
                  </div>
                )}
              </div>
              {/* ====================== END COUPON ====================== */}

              {/* Total Amount */}
              <div className="bg-orange-950/30 border border-orange-500/30 rounded-2xl p-5">
                <div className="flex justify-between text-sm">
                  <span>Price per card</span>
                  <span>₹110</span>
                </div>

                {couponApplied && discount > 0 && (
                  <div className="flex justify-between text-sm text-green-500 mt-1">
                    <span>Discount ({discount}%)</span>
                    <span>- ₹{Math.round((numCards * 110) * (discount / 100))}</span>
                  </div>
                )}

                <div className="flex justify-between text-xl font-bold mt-3 pt-3 border-t border-orange-500/20">
                  <span>Total Amount</span>
                  <span className="text-orange-500">₹{calculateTotal()}</span>
                </div>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="p-6 border-t border-card-border flex gap-3 sticky bottom-0 bg-card-bg">
              <button
                onClick={() => { setShowAddPackage(false); resetForm(); }}
                className="flex-1 py-3.5 border border-card-border rounded-2xl font-medium hover:bg-secondary-bg transition"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmPayment}
                className="flex-1 py-3.5 bg-orange-600 hover:bg-orange-700 text-white rounded-2xl font-medium transition"
              >
                Confirm & Pay
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}